import { SAVE, VALUE_CHANGED, RESET, LOAD } from './constants';

/**
 * Changes the input field of the form
 *
 * @param  {form} form The new text of the input field
 *
 * @return {object}    An action object with a type of CHANGE_USERNAME
 */
export function saveFormData(form) {
  return {
    type: SAVE,
    payload: form,
  };
}

export function handleFormDataChange(propertyName, value) {
  return {
    type: VALUE_CHANGED,
    propertyName,
    value,
  };
}

export function resetFormData() {
  return {
    type: RESET,
  };
}

export function loadFormData(form) {
  return {
    type: LOAD,
    payload: form,
  };
}



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepDeclaration/actions.js